import { ServerConnection } from "./serverConnection";

export abstract class WsDao<TDto> {
    public abstract getById(serverConnection: ServerConnection, id: string): Promise<TDto> ;

    public abstract save(serverConnection: ServerConnection, entity: TDto): Promise<TDto> ;
}
